/**
 * Utility function to get the display name of a client
 * Prioritizes company_name, falls back to name if company_name is null or empty
 */
export function getClientDisplayName(client: {
  company_name?: string | null;
  name?: string | null;
}): string {
  if (client.company_name && client.company_name.trim()) {
    return client.company_name;
  }
  return client.name || 'Client sans nom';
}
